import { TableRow } from '@mui/material';
import { CustomTableCell } from '../../../../components/Table/TableCell';
import { CustomTableActions } from '../../../../components/Table/TableActions';
import { mutationResponseHandler } from '../../../../utils/mutationResponseHandler';
import { useApiMutation } from '../../../../query/hooks';
import { useIntl } from 'react-intl';
import { graphql } from '../../../../gql';
import { Tag } from './TagsResourcePage';
import { FC } from 'react';
import { useSnackbar } from '../../../../store/snackbar';

const deleteTagMutation = graphql(`
	mutation deleteTagMutation($id: UUID!) {
		deleteTag(by: { id: $id }) {
			ok
			errorMessage
		}
	}
`);

type Props = Readonly<{ row: Tag; onEdit: (tag: Tag) => void }>;
const TagsTableRow: FC<Props> = ({ row, onEdit }) => {
	const intl = useIntl();
	const { openSnackbar } = useSnackbar();

	const { mutate: deleteTag } = useApiMutation(deleteTagMutation, {
		onSuccess: async (result) => {
			mutationResponseHandler({
				result: result.deleteTag.ok,
				toastMessages: {
					success: intl.formatMessage({ id: 'resources.tags.delete.success' }),
					error: intl.formatMessage({ id: 'common.error.default' }),
				},
				errorMessage: result.deleteTag.errorMessage,
				openSnackbar,
			});
		},
	});

	return (
		<TableRow hover key={row.id}>
			<CustomTableCell content={row.name} />
			<CustomTableCell content={`${row.paginateActivities.pageInfo.totalCount}x`} />
			<CustomTableCell isActionButton>
				<CustomTableActions openEdit={() => onEdit(row)} onDelete={() => deleteTag({ id: row.id })} />
			</CustomTableCell>
		</TableRow>
	);
};

export { TagsTableRow };
